type EmptyTripInfoProps = {
  message: string;
};

export const EmptyTripInfo = ({ message }: EmptyTripInfoProps) => (
  <div className="w-full flex bg-base-80 rounded-lg py-2 px-3">
    <span className="text-s-r text-base-20">{message}</span>
  </div>
);
